var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "empty-numbers" },
    [
      _vm.error
        ? [
            _c("i", { staticClass: "material-icons error-icon" }, [
              _vm._v("error_outline"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "error-message" }, [
              _vm._v(_vm._s(_vm.error.message || "Bir hata oluştu")),
            ]),
          ]
        : !_vm.hasValidSettings
        ? [
            _c("i", { staticClass: "material-icons settings-icon" }, [
              _vm._v("settings"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "message" }, [
              _vm._v("Widget ayarları yapılandırılmamış"),
            ]),
          ]
        : [_c("loading-wave", { attrs: { text: "Veriler yükleniyor..." } })],
      _vm._v(" "),
      !_vm.error
        ? _c(
            "a-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.$emit("edit")
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("settings")]),
              _vm._v("\n        Ayarları Yapılandır\n    "),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }